export const notFound = "Not Found"